/* eslint-disable @nx/enforce-module-boundaries */
import {
  Avatar,
  Button,
  HStack,
  Link,
  SeeMore,
  Text,
} from '@mybridge/ui';
import { forwardRef, useMemo, useContext, useEffect, useState } from 'react';
// import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { formatCommaSeparated, formatCommaSeparatedLocation, formatLocation } from 'v4/lib/commons';
import { TeamsContext, useTeamsContext } from 'v4/snippets/teams/context';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenAuthModal } from 'v4/store/actions/auth.actions';
import { TeamNewIcon } from '@mybridge/icons';
import { Spinner, Stack } from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
// Import the action to fetch invited users
import { getTeamMemberList } from 'v4/store/actions/teamCommunity.actions';
import { useRouter } from 'next/router';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';

export const SearchTeamCard = forwardRef(
  ({ team, refetchTeamsSearch, ...props }, ref) => {
    const {
      requestToJoinTeam,
      requestToJoinTeamLoading,
      withdrawRequestToJoinTeam,
      withdrawRequestToJoinTeamLoading,
      teamJoinRequests,
      newTeamJoinRequests,
      isRequested,
      setSelectedTeam,
      selectedTeam,
    } = useContext(TeamsContext);
    
    const [slug, setSlug] = useState(null);
    const [loadingInvite, setLoadingInvite] = useState(false);
    
    useEffect(()=>{
      setSlug(team?.slug);
    }, [team])
  
    const teamsContext = useTeamsContext({
      slug,
    });

    const { acceptInvite } = teamsContext;

    const { t } = useTranslator();
    const { userProfileInfo } = useSelector((state) => state?.userProfile);
    const dispatch = useDispatch();
    const { loggedIn } = useSelector((s) => s.user);
    const router = useRouter();
    
    // Local state for invited users for this specific team
    const [teamInvitedUsers, setTeamInvitedUsers] = useState([]);
    const [invitedUsersLoading, setInvitedUsersLoading] = useState(false);
    const [invitedUsersFetched, setInvitedUsersFetched] = useState(false);

    const isOrganizer = !!team?.organizer_list?.some(
      (organizer) => organizer?.user?.id === userProfileInfo?.id
    );

    const [currTeam, setCurrTeam] = useState();

    // Fetch invited users for this specific team
    const fetchTeamInvitedUsers = async () => {
      if (!team?.id || !userProfileInfo?.id || invitedUsersFetched) return;
      
      setInvitedUsersLoading(true);
      
      try {
        const response = await dispatch(
          getTeamMemberList({
            for_team_community_id: team.id,
            list_type: 'invited',
          })
        );
        const invitedUsers = response?.payload?.results ?? [];
        setTeamInvitedUsers(invitedUsers);
        setInvitedUsersFetched(true);
      } catch (error) {
        console.error('Error fetching invited users:', error);
      } finally {
        setInvitedUsersLoading(false);
      }
    };

    // Fetch invited users when component mounts or team changes
    // useEffect(() => {
    //   if (team?.id && userProfileInfo?.id && loggedIn) {
    //     fetchTeamInvitedUsers();
    //   }
    // }, [team?.id, userProfileInfo?.id, loggedIn]);
    
    useEffect(() => {
      if (
        team?.id &&
        userProfileInfo?.id &&
        loggedIn &&
        !team?.is_joined &&
        !team?.is_requested
      ) {
        fetchTeamInvitedUsers();
      }
    }, [team?.id, userProfileInfo?.id, loggedIn, team?.is_joined, team?.is_requested]);

    // Checks if current user is invited to this specific team
    const isInvited = useMemo(() => {
      if (!userProfileInfo?.id || !teamInvitedUsers.length) return false;
      
      const invited = teamInvitedUsers.some(
        (invitedUser) => {
          const userId = invitedUser?.user?.id || invitedUser?.id;
          const isMatch = userId === userProfileInfo?.id;          
          return isMatch;
        }
      );      
      return invited;
    }, [teamInvitedUsers, userProfileInfo?.id]);

    let location = useMemo(() => {
      // let loc = formatLocation(team);
      let loc = formatCommaSeparatedLocation(team?.location);
      return loc?.length ? loc : team?.location;
    }, []);

    useEffect(() => {
      if (teamJoinRequests) {
        const requestedTeam = teamJoinRequests?.find(
          (obj) => obj?.team === team?.id
        );
        setCurrTeam(requestedTeam);
      }
    }, [teamJoinRequests]);

    const htmlToPlainText = (html) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      let str = tempDiv.textContent || tempDiv.innerText || '';
      return str.length > 150 ? str.slice(0, 150) + '...' : str;
    };

    // Handle redirect to team page for invited users
    const handleGoToTeam = () => {
      setLoadingInvite(true);

      if (!loggedIn) {
        dispatch(setOpenAuthModal('sign-in'));
        return;
      }
      
      if (!team?.slug) {
        return;
      }
      
      acceptInvite?.(userProfileInfo, team, true).then(()=>{
        setLoadingInvite(false)
      });
    };

    // if (currTeam) {
    //   console.log("currTeam", currTeam);
    // }
    return (
      <Stack h="295px" w = {isMobile?"100%":"464px"} {...props}>
        <HStack display={isMobile?"contents":"flex"} w="100%">
          <HStack flex={1} h = "80px" w = "80px" m={isMobile?"8px 8px 18px 0":3}>
            <a href={'/t/' + team?.slug}>
              {team?.image_logo ? (
                <Avatar h = "80px" w = "80px" name={team?.name} src={team?.image_logo} size="xl" />
              ) : (
                <Stack
                  style={{ backgroundColor: '#D9D9D9', gap : '16px' }}
                  textAlign="center"
                  alignItems="center"
                  justifyContent="center"
                  width="80px"
                  height="80px"
                  borderRadius="50px"
                  overflow="hidden"
                  
                >
                  <TeamNewIcon width="65%" height="65%" color="#9F9F9F" />
                </Stack>
              )}
            </a>
              {/* {isMobile&&( <Stack marginLeft="35vw"><Button
                onClick={(e) => {
                  if (loggedIn) {
                    setSelectedTeam(team);
                    requestToJoinTeam(team);
                  } else {
                    dispatch(setOpenAuthModal('sign-in'));
                  }
                }}
                isLoading={
                  selectedTeam?.id === team?.id && requestToJoinTeamLoading
                }
                // border="1px solid gray"
                borderRadius="27px"
                bg="#E4E6EB"
                color="#5B5B5B"
                fontSize="14px"
                padding = "8px 35px"
                mb = {1}
                variant = ""
                _hover={{
                  bg: 'gray.100',
                }}
              >
                {t('myCalendar.join') || "Join"}
              </Button>
              </Stack>)} */}

            {isMobile && (
              <Stack marginLeft="35vw">
                {isInvited ? (
                  <Button
                    onClick={handleGoToTeam}
                    isLoading={invitedUsersLoading}
                    borderRadius="27px"
                    bg="#E4E6EB"
                    color="#5B5B5B"
                    fontSize="14px"
                    padding = "8px 35px"
                    mb = {1}
                    variant = ""
                    _hover={{
                      bg: 'gray.100',
                    }}
                  >
                    {t('searchPage.viewTeam') || "View Team"}
                  </Button>
                ) : (
                  <Button
                    onClick={(e) => {
                      if (loggedIn) {
                        setSelectedTeam(team);
                        requestToJoinTeam(team);
                      } else {
                        dispatch(setOpenAuthModal('sign-in'));
                      }
                    }}
                    isLoading={
                      (selectedTeam?.id === team?.id && requestToJoinTeamLoading) ||
                      invitedUsersLoading
                    }
                    borderRadius="27px"
                    bg="#E4E6EB"
                    color="#5B5B5B"
                    fontSize="14px"
                    padding="8px 35px"
                    mb={1}
                    variant=""
                    _hover={{
                      bg: 'gray.100',
                    }}
                  >
                    {t('myCalendar.join') || "Join"}
                  </Button>
                )}
              </Stack>
            )}
          </HStack>

          <HStack w={isMobile?"330px":"100%"} flex={5} mt={-2}>
            <Stack gap={"0px"} flex={2}>
              <Text
                // size="xl"
                color="#2E2E2A"
                as={Link}
                href={'/t/' + team?.slug}
                maxW={'300'}
                truncate
                fontWeight="medium"
                gap = "14px"
                fontSize={"24px"}
                lineHeight={"24px"}
              >
                {team?.name}
              </Text>
              <Text size="md">
                {formatCommaSeparated(
                  [
                    team?.industry_name?.[0]?.name ?? team?.industry_name,
                    location,
                  ],
                  ' | '
                )}
              </Text>
            </Stack>
          </HStack>
        </HStack>

      
        <Stack w={isMobile?"330px":"100%"} overflow="hidden" color={"#5B5B5B"} mt={2} height={"90px"}>
          {team?.desc?.length>110 && <>{htmlToPlainText(team?.desc).slice(0,110)+"..."}</>}
          {team?.desc?.length<150 && <>{htmlToPlainText(team?.desc)}</>}

          {/* {team?.desc?.length ? (
              team?.desc?.startsWith?.('<') ? (
                <SeeMore
                  isSeeMoreLinkVisible={false}
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  linkProps={{ onClick: (e) => {}, href: '/t/' + team?.slug }}
                  html={team?.desc}
                  // maxHeight="20px"
                />
              ) : (
                <SeeMore
                  // eslint-disable -next-line @typescript-eslint/no-empty-function
                  linkProps={{ onClick: (e) => {}, href: '/t/' + team?.slug }}
                  text={team?.desc}
                  // maxHeight="20px"
                />
              )
            ) : (
              ''
            )} */}
        </Stack>
      
        
        {!isMobile && <HStack mt={12}>
          {team?.is_joined ? (
            <>
              <Button as={Link} href={`/t/${team?.slug}`} variant="secondary">
                {t('searchPage.viewTeam') || "View Team"}
              </Button>
            </>
          ) : team?.is_requested ||
            (currTeam && currTeam.status === 'requested') ? (
            <Button
              onClick={(e) => {
                setSelectedTeam(team);
                withdrawRequestToJoinTeam(userProfileInfo);
              }}
              isLoading={
                selectedTeam?.id === team?.id &&
                withdrawRequestToJoinTeamLoading
              }
              border="1px solid gray"
              borderRadius="27px"
              bg="none"
              color="#5B5B5B"
              fontSize="14px"
              padding = "8px 35px"
              mb = {1}
              variant = "outlined"
              _hover={{
                bg: 'gray.100',
              }}
            >
              {t('teams.withdrawRequest') || "Withdraw Request"}
            </Button>
          ) : isInvited ? (
            // Show View Team button for invited users (desktop)
            <Button
              onClick={handleGoToTeam}
              isLoading={invitedUsersLoading}
              variant="secondary"
            >
              {loadingInvite? <Spinner/> : (t('teams.acceptInvite') || "Accept Invite")}
            </Button>
          ) : 
            !loggedIn?(<ForceSignInWrapper>
            <Button
              onClick={(e) => {
                if (loggedIn) {
                  setSelectedTeam(team);
                  requestToJoinTeam(team);
                } else {
                  dispatch(setOpenAuthModal('sign-in'));
                }
              }}
              isLoading={
                selectedTeam?.id === team?.id && requestToJoinTeamLoading
              }
              size="sm"
              px={8}
              py={5}
              variant="secondary"
              borderRadius="full"
            >
               {t('myCalendar.join') || "Join"} 
            </Button>
            </ForceSignInWrapper>)

            
           :( <Button
            onClick={(e) => {
              if (loggedIn) {
                setSelectedTeam(team);
                requestToJoinTeam(team);
              } else {
                dispatch(setOpenAuthModal('sign-in'));
              }
            }}
            isLoading={
              selectedTeam?.id === team?.id && requestToJoinTeamLoading
            }
            border="1px solid gray"
            borderRadius="27px"
            bg="none"
            color="#5B5B5B"
            fontSize="14px"
            padding = "8px 35px"
            mb = {1}
            variant = "outlined"
            _hover={{
              bg: 'gray.100',
            }}
          >
             {t('myCalendar.join') || "Join"}
          </Button>

          )}
        </HStack>}


      </Stack>
    );
  }
);
